/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Deleted1Inputs */

const vi_cmspost_deleted1 = /** @type {(inputs: Cmspost_Deleted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xoá bài viết.`)
};

/**

* @param {Cmspost_Deleted1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_deleted1 = /** @type {((inputs?: Cmspost_Deleted1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Deleted1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_deleted1(inputs)
});
export { cmspost_deleted1 as "cmsPost_deleted" }